import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AccountSettings = () => {
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const currencies = ['USDT', 'XOF', 'USD', 'EUR', 'GBP'];

    // Charge la devise actuelle de l'utilisateur au chargement
    useEffect(() => {
        const fetchUserCurrency = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const config = { headers: { 'x-auth-token': token } };
                const res = await axios.get('/api/user/dashboard-data', config); // Réutilise l'API du tableau de bord
                setSelectedCurrency(res.data.user.currency || 'USDT');
            } catch (err) {
                console.error(err);
                setMessage('Impossible de charger la devise actuelle.');
            }
        };
        fetchUserCurrency();
    }, [navigate]);

    const handleCurrencyChange = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
            return;
        }

        try {
            const config = { headers: { 'x-auth-token': token } };
            const body = { currency: selectedCurrency };
            await axios.put('/api/user/settings/currency', body, config);
            setMessage('Devise mise à jour avec succès !');
        } catch (err) {
            console.error(err);
            setMessage('Erreur lors de la mise à jour de la devise.');
        }
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Paramètres du compte</h2>
            <div className="card p-4 shadow-sm">
                <h4>Choisir votre devise</h4>
                <div className="mb-3">
                    <label htmlFor="currency-select" className="form-label">Devise :</label>
                    <select
                        id="currency-select"
                        className="form-control"
                        value={selectedCurrency}
                        onChange={(e) => setSelectedCurrency(e.target.value)}
                    >
                        {currencies.map(c => (
                            <option key={c} value={c}>{c}</option>
                        ))}
                    </select>
                </div>
                <button
                    className="btn btn-primary"
                    onClick={handleCurrencyChange}
                >
                    Mettre à jour la devise
                </button>
                {message && <div className={`mt-3 alert ${message.includes('succès') ? 'alert-success' : 'alert-danger'}`}>{message}</div>}
            </div>
        </div>
    );
};

export default AccountSettings;